import { render } from "./Plans.vue?vue&type=template&id=16574d7e&scoped=true"
import script from "./Plans.vue?vue&type=script&lang=js"
export * from "./Plans.vue?vue&type=script&lang=js"

import "./Plans.vue?vue&type=style&index=0&id=16574d7e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16574d7e"]])

export default __exports__